import axios from 'axios'
import settings from '@/modules/settings'

const Axios = axios.create({
  baseURL:
    process.env.NODE_ENV === 'production' ? process.env.VUE_APP_SERVER : ''
})
Axios.interceptors.request.use(
  function(config) {
    let token = settings.get('token') || ''
    if (token) config.headers['Authorization'] = `Bearer ${token}`
    return config
  },
  function(error) {
    return Promise.reject(error)
  }
)

export default Axios
